import { render, staticRenderFns } from "./MaintainerIssues.vue?vue&type=template&id=be0541ee&scoped=true&"
import script from "./MaintainerIssues.vue?vue&type=script&lang=js&"
export * from "./MaintainerIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0541ee",
  null
  
)

export default component.exports